/**
 * Entrance for the story sections.
 *
 * The element is VISIBLE by default and this script is what hides it — it
 * adds .is-armed, then removes it on intersection. Written the other way
 * round (hidden in CSS, revealed by script) a blocked or errored script
 * leaves the whole section permanently invisible, which is a far worse
 * failure than no animation.
 *
 * Reduced motion is checked here as well as in the CSS, so under that
 * preference nothing is armed at all and no observer is created.
 */
(function () {
  "use strict";
  if (window.__calmyStory) return;
  window.__calmyStory = true;

  var still = window.matchMedia("(prefers-reduced-motion: reduce)");

  function init(el) {
    if (el.__calmyStoryDone) return;
    el.__calmyStoryDone = true;
    if (still.matches || !("IntersectionObserver" in window)) return;

    el.classList.add("is-armed");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.remove("is-armed");
        en.target.classList.add("is-in");
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    io.observe(el);
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-calmy-reveal]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
